'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = require('simple-assign');

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  width: '100%',
  position: 'relative',
  textAlign: 'initial'
};

var TabTemplate = function TabTemplate(_ref) {
  var children = _ref.children,
      selected = _ref.selected,
      style = _ref.style;

  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
  if (!selected) {
    templateStyle.height = 0;
    templateStyle.overflow = 'hidden';
  }

  return _react2.default.createElement(
    'div',
    { style: templateStyle },
    children
  );
};

process.env.NODE_ENV !== "production" ? TabTemplate.propTypes = {
  children: _react.PropTypes.node,
  selected: _react.PropTypes.bool,
  style: _react.PropTypes.object
} : void 0;

exports.default = TabTemplate;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Tabs/TabTemplate.js
// module id = 1069
// module chunks = 1